export default __webpack_public_path__ + "static/media/PFS_withText.310b5a4b.png";